/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { DataStore, IDataStore } from './IDataStore';

/**
 * Parser for HUTT format (RuntimeDataInputStore) JSON.
 *
 * HUTT is the JSON-based format used by viz-client to represent animation data.
 * It contains mark data (positions, colors, sizes, etc.), encodings, axes info, etc.
 *
 * Note: This is a simplified parser that handles JSON directly.
 * The original C++ version uses a binary format (WASM heap, JABBA packed),
 * but per architect guidance, we work with HUTT → JSON directly.
 *
 * Design Philosophy:
 * - Start simple: Parse basic JSON structure
 * - Validate incrementally: Add checks as we discover edge cases
 * - Extensible: Easy to add support for more complex HUTT features
 *
 * Example HUTT JSON structure:
 * {
 *   "marks": {
 *     "mark_123": {
 *       "x": 100,
 *       "y": 200,
 *       "color": 0xFFFF0000,
 *       "size": 10,
 *       "angle": 45
 *     }
 *   }
 * }
 */
export class HuttParser {
  /**
   * Parse HUTT JSON into an IDataStore.
   *
   * @param huttJson - The HUTT format JSON object (already parsed, not a string)
   * @returns IDataStore representation
   * @throws Error if huttJson is null/undefined or invalid
   *
   * @example
   * const hutt = {
   *   marks: {
   *     mark_123: { x: 100, y: 200, color: 0xFFFF0000 }
   *   }
   * };
   * const dataStore = HuttParser.parse(hutt);
   * console.log(dataStore.getValue('marks.mark_123.x')); // 100
   */
  static parse(huttJson: any): IDataStore {
    // Validation
    if (huttJson === null || huttJson === undefined) {
      throw new Error('HuttParser.parse: huttJson is null or undefined');
    }

    if (typeof huttJson !== 'object') {
      throw new Error('HuttParser.parse: huttJson must be an object');
    }

    // For now, we simply wrap the JSON object in a DataStore
    // This works because HUTT JSON structure matches our dot-separated path convention
    //
    // Future enhancements:
    // - Validate required fields
    // - Handle typed arrays (Int32Array, Float64Array) if needed
    // - Transform special structures (e.g., nested encodings)
    // - Add schema validation

    return new DataStore(huttJson);
  }

  /**
   * Validate that a HUTT JSON object contains the expected structure.
   * This is a basic check - can be expanded as we learn more about HUTT format.
   *
   * @param huttJson - The HUTT JSON to validate
   * @returns true if valid, false otherwise
   */
  static validate(huttJson: any): boolean {
    if (huttJson === null || huttJson === undefined) {
      return false;
    }

    if (typeof huttJson !== 'object') {
      return false;
    }

    // Basic structure check: HUTT should be a plain object (not array)
    if (Array.isArray(huttJson)) {
      return false;
    }

    // For now, any non-null object is considered valid
    // We can add more specific validation as we learn the HUTT format
    return true;
  }

  /**
   * Parse HUTT JSON string into an IDataStore.
   *
   * @param huttJsonString - The HUTT format JSON as a string
   * @returns IDataStore representation
   * @throws Error if JSON parsing fails or validation fails
   *
   * @example
   * const huttStr = '{"marks": {"mark_123": {"x": 100}}}';
   * const dataStore = HuttParser.parseString(huttStr);
   */
  static parseString(huttJsonString: string): IDataStore {
    if (typeof huttJsonString !== 'string') {
      throw new Error('HuttParser.parseString: input must be a string');
    }

    let parsed: any;
    try {
      parsed = JSON.parse(huttJsonString);
    } catch (error: any) {
      throw new Error(`HuttParser.parseString: JSON parsing failed - ${error.message}`);
    }

    return this.parse(parsed);
  }
}
